<div data-bs-spy="scroll" data-bs-target="#navbar-example2" data-bs-offset="10" tabindex="0">
  <app-header></app-header>
  <main id="mainContent" tabindex="-1">
    <!-- whatsapp floating button -->
    <app-whatsapp></app-whatsapp>
    <!-- END whatsapp floating button -->
    <section class="pb-5 position-relative">
      <div class="position-relative faculty-hero d-flex">
        <div class="slid-img position-absolute w-100 h-100 top-0 end-0 overflow-hidden">
          <img class="position-absolute" [src]="faculty_image" alt="" />
          <div class="black-layer position-absolute top-0 end-0 h-100 w-100"></div>
        </div>
        <div
          class="position-relative d-flex align-items-lg-end justify-content-center institute-pref flex-column inner">
          <div class="blend-darken-bg position-absolute top-0 end-0 h-100 w-100"></div>
          <div class="pref position-relative text-white pe-lg-5 pe-3 ms-3 animate__animated animate__slideInRight wow">
            <h1 class="heading-font d-inline-block pt-5">
              <label class="d-block text-sm-start">{{faculty_about.DATE_ESTABLISH}}</label>
              {{faculty_about.FACULTY_Name}}
            </h1>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb animate__animated animate__fadeInDown">
                <li class="breadcrumb-item">
                  <a class="text-white">أكادميه الفنون</a>
                </li>
                <li class="breadcrumb-item">
                  <a class="text-white">
                    {{faculty_about.FACULTY_Name}}
                  </a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  عن المعهد
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid floated-contatiner-top position-relative">
      <div class="row">
        <div class="col-lg-11 offset-lg-1 bg-white">
          <div class="col-11 ps-3">
            <section class="pt-4 mt-3 pb-5">
              <h3
                class="text-center heading-font heading-style mb-4 fw-normal animate__animated animate__fadeInUp animate__faster wow">
                عن المعهد
              </h3>
              <p class="fs-5 fw-medium animate__animated animate__fadeInUp animate__fast wow">
                {{faculty_about.ABOUT_FACULTY}}
              </p>
            </section>
            <!--brife grid-->
            <section class="pb-5">
              <div class="about-grid">
                <div class="about-card animate__animated animate__fadeInUp animate__faster wow">
                  <div class="about-card-head">
                    <span class="about-card-accent"></span>
                    <h3 class="heading-font mb-0">منذ {{faculty_about.DATE_ESTABLISH}}</h3>
                  </div>
                  <p class="mb-0">{{faculty_about.WORD_ABOUT_FACULTY}}</p>
                </div>
                <div class="about-card animate__animated animate__fadeInUp animate__fast wow">
                  <div class="about-card-head">
                    <span class="about-card-accent"></span>
                    <h3 class="heading-font mb-0">الرؤية</h3>
                  </div>
                  <p class="mb-0">{{faculty_about.FACULTY_VISION}}</p>
                </div>
                <div class="about-card animate__animated animate__fadeInUp animate__fast wow">
                  <div class="about-card-head">
                    <span class="about-card-accent"></span>
                    <h3 class="heading-font mb-0">أهداف {{faculty_about.FACULTY_Name}}</h3>
                  </div>
                  <p class="mb-0">{{faculty_about.WHY_THIS_FACULTY}}</p>
                </div>
                <div class="about-card animate__animated animate__fadeInUp wow">
                  <div class="about-card-head">
                    <span class="about-card-accent"></span>
                    <h3 class="heading-font mb-0">آفاق حياتك المهنية</h3>
                  </div>
                  <p class="mb-0">{{faculty_about.YOUR_CAREER}}</p>
                </div>
              </div>
            </section>
            <!--END brife grid-->

          </div>
          <!--Fuculty Managers-->

          <section class="col pt-4 mt-2 pb-5">
            <h3
              class="heading-font heading-style mb-4 fw-normal animate__animated animate__fadeInUp animate__faster wow">
              عمداء المعهد
            </h3>
            <div class="manger-swiper-container">
              <div class="swiper managers-swiper">
                <swiper [config]="mangerConfig">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let item of faculty_about.FACULTIES_DEANS">
                      <div class="overflow-hidden swiper-element manager-card"
                        [class.latest]="item.is_current == true">
                        <div class="manager-photo position-relative overflow-hidden">
                          <img class="hover-scale fit-img position-absolute"
                            src="{{item.DEAN_IMG ? item.DEAN_IMG : 'assets/img/instructor-default.jpg'}}" alt="">
                        </div>
                        <div class="manager-info bg-white text-black p-4">
                          <h4 class="fw-medium fs-4 mb-0 pb-2 lh-md">
                            أ.د.{{item.FULL_NAME}}
                          </h4>
                          <span class="d-inline-block pt-1 border-top border-primary text-primary fs-6 fw-medium"
                            *ngIf="item.is_current == true">العميد الحالي</span>
                          <span class="d-inline-block pt-1 border-top border-primary text-black fs-6 fw-medium"
                            *ngIf="item.is_current != true">
                            {{item.START_YEAR}} - {{item.END_YEAR}}
                          </span>
                          <p class="pt-2 mb-0 opacity-75 fw-medium">
                            {{item.ADBOUT_DEAN}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </swiper>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </section>

          <!--Graduated-->

          <section class="py-5">
            <h2
              class="heading-font heading-style mb-4 pb-3 fw-normal animate__animated animate__fadeInUp animate__faster wow">
              الخريجين</h2>
            <!-- Swiper -->
            <div class="animate__animated animate__fadeInUp wow">
              <swiper *ngIf="faculty_about.graduates?.length" [config]="gradConfig" class="swiper graduatesSwiper">
                <div class="swiper-wrapper">
                  <ng-container *ngFor="let item of faculty_about.graduates">
                    <div class="swiper-slide graduate-slide" *ngFor="let grad of item.graduates">
                      <div class="graduate-card">
                        <div class="graduate-card-media">
                          <img class="graduate-card-img" src="{{grad.image}}" alt="">
                        </div>
                        <div class="graduate-card-body">
                          <h3 class="graduate-card-name heading-font">{{grad.name}}</h3>
                          <span class="graduate-card-faculty" *ngIf="item.graduation_year">دفعة
                            {{item.graduation_year}}</span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="swiper-pagination graduates-pagination"></div>
              </swiper>
            </div>


          </section>
          <!--END Graduated-->
        </div>
      </div>
    </div>
    <!-- <section class="container-fluid pt-5 pt-5 pb-lg-5 pb-3">
      <div class="row">
        <div
          class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__faster wow">
          <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
            <div class="fw-medium flex-fill p-1">
              موقع الطالب
              <p class="mb-0 text-gray mt-1">
                تعرف على المواد و المهام و النتيجة
              </p>
            </div>
            <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
          </a>
        </div>
        <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow">
          <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
            <div class="fw-medium flex-fill p-1">
              موقع هيئة التدريس
              <p class="mb-0 text-gray mt-1">تابع متطلبات الطلبه</p>
            </div>
            <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
          </a>
        </div>
        <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow">
          <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
            <div class="fw-medium flex-fill p-1">
              موقع الموظفين
              <p class="mb-0 text-gray mt-1">تابع متطلبات الطلبه</p>
            </div>
            <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
          </a>
        </div>
        <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp wow">
          <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
            <div class="fw-medium flex-fill p-1">
              خدمات الخريجين
              <p class="mb-0 text-gray mt-1">
                تعرف على الخدمات الخاصه بالخرجين
              </p>
            </div>
            <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
          </a>
        </div>
      </div>
    </section> -->
  </main>
  <!-- <app-footer></app-footer> -->
</div>